export const PRODUCT_FRUITS_WORKSPACE_CODE = 'QaPm9Dc29N18z3UY'